import { UserConsumer } from '../../core/providers/UserProvider';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import StandardAppBar from '../StandardAppBar';
import AdministrationApplications from './AdministrationApplications';
import AdministrationManager from './AdministrationManager';

class AdministrationApplication extends Component {

  render() {

    return (
      <UserConsumer>
        {({ user }) => {
          return <Switch>
            <Route exact path="/administration" render={
              (props) => <AdministrationApplications {...props} user={user} appBar={<StandardAppBar title="Administration" />} />} />
            <Route path={"/administration/*"} render={
              (props) => <AdministrationManager {...props} user={user} />} />
          </Switch>;
        }}
      </UserConsumer>
    );
  }
}

export default AdministrationApplication;